export default {
    funnies (state) {
      return state.funnies
    },

    selectedFunny (state) {
        return state.selectedFunny
    },

    getFunny: state => (funnyId) => {
      return state.funnies().find(funny => funny.funnyId === funnyId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/funnies/getters.js